import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const router =  new Router({
	mode:'',
	routes:[
		{
		  path: '/',
		  redirect: '/index'
		},
    	{
			path: '/index',
			name: 'index',
			component: () => import('@/views/Home.vue'),
			meta: {
			  title: '首页'
			}
		},
		{
			path: '/register',
			name: 'register',
			component: () => import('@/views/Register.vue'),
			meta: {
			  title: '注册'
			}
		},
		{
			path: '/login',
			name: 'login',
			component: () => import('@/views/Login.vue'),
			meta: {
			  title: '登录'
			}
		},
		
		{
			path: '/newsIndex',
			name: 'newsIndex',
			component: () => import('@/views/Pages/News/index.vue'),
			meta: {
			  title: '新闻列表'
			}
		},
    	{
			path: '/newsPage',
			name: 'newsPage',
			component: () => import('@/views/Pages/News/page.vue'),
			meta: {
			  title: '新闻详情'
			}
		},
		{
			path: '/merchantIndex',
			name: 'merchantIndex',
			component: () => import('@/views/Pages/Publish/merchant/index.vue'),
			meta: {
			  title: '商家列表'
			}
		},
		{
			path: '/merchantView',
			name: 'merchantView',
			component: () => import('@/views/Pages/Publish/merchant/view.vue'),
			meta: {
			  title: '商家详情'
			}
		},
		{
			path: '/merchant',
			name: 'merchant',
			component: () => import('@/views/Pages/Publish/merchant/list.vue'),
			meta: {
			  title: '商家'
			}
		},
		{
			path: '/merchantAdd',
			name: 'merchantAdd',
			component: () => import('@/views/Pages/Publish/merchant/add.vue'),
			meta: {
			  title: '添加商家'
			}
		},
		{
			path: '/recruitmentIndex',
			name: 'recruitmentIndex',
			component: () => import('@/views/Pages/Publish/recruitment/index.vue'),
			meta: {
			  title: '招聘列表'
			}
		},
		// {
		// 	path: '/recruitmentView',
		// 	name: 'recruitmentView',
		// 	component: () => import('@/views/Pages/Publish/recruitment/view.vue'),
		// 	meta: {
		// 	  title: '招聘详情'
		// 	}
		// },
		{
			path: '/recruitment',
			name: 'recruitment',
			component: () => import('@/views/Pages/Publish/recruitment/list.vue'),
			meta: {
			  title: '我的招聘'
			}
		},
		{
			path: '/recruitmentAdd',
			name: 'recruitmentAdd',
			component: () => import('@/views/Pages/Publish/recruitment/add.vue'),
			meta: {
			  title: '添加招聘'
			}
		},
		{
			path: '/easyBookIndex',
			name: 'easyBookIndex',
			component: () => import('@/views/Pages/Publish/easyBook/index.vue'),
			meta: {
			  title: '易书列表'
			}
		},
		{
			path: '/easyBookView',
			name: 'easyBookView',
			component: () => import('@/views/Pages/Publish/easyBook/view.vue'),
			meta: {
			  title: '易书详情'
			}
		},
		{
			path: '/easyBook',
			name: 'easyBook',
			component: () => import('@/views/Pages/Publish/easyBook/list.vue'),
			meta: {
			  title: '我的易书'
			}
		},
		{
			path: '/easyBookAdd',
			name: 'easyBookAdd',
			component: () => import('@/views/Pages/Publish/easyBook/add.vue'),
			meta: {
			  title: '添加易书'
			}
		},
		{
			path: '/notifications',
			name: 'notifications',
			component: () => import('@/views/Pages/BasicInfo/Notifications/index.vue'),
			meta: {
			  title: '通知列表'
			}
		},
		{
			path: '/myInformation',
			name: 'myInformation',
			component: () => import('@/views/Pages/BasicInfo/MyInformation/index.vue'),
			meta: {
			  title: '我的信息'
			}
		},
		{
			path: '/changePassword',
			name: 'changePassword',
			component: () => import('@/views/Pages/BasicInfo/ChangePassword/index.vue'),
			meta: {
			  title: '修改密码'
			}
		},
		{
			path: '/message',
			name: 'message',
			component: () => import('@/views/Pages/BasicInfo/Message/index.vue'),
			meta: {
			  title: '消息'
			}
		},
		{
			path: '/advertisement',
			name: 'advertisement',
			component: () => import('@/views/Pages/Advertisement/index.vue'),
			meta: {
			  title: '广告'
			}
		},
		{
			path: '/search',
			name: 'search',
			component: () => import('@/views/Search.vue'),
			meta: {
			  title: '搜索'
			}
		},
		

	]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export  default router;


// WEBPACK FOOTER //
// ./src/router/index.js